// imports react
import React, { useEffect, useState } from "react";

//imports libraries
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

//imports components
import styles from "../styles/questionary.module.css";

import { logoutUser } from "../logoutUser";
import { userLogged } from "../userLogged";
import { verifyUserPaid } from "../verifyUserPaid";
import { Menu } from "../components/Menu";
import axios from "axios";
import { urlAPI_Current } from "../config";
import Swal from "sweetalert2";
import useAccessTracking from "../components/useAccessTracking";
import { verifyAuthToken } from "../verifyAuthToken";

export function QuestionaryAlert() {
  const [userData, setUserData] = useState([]);
  const navigateTo = useNavigate();

  const [searchParams] = useSearchParams();
  let success = searchParams.get('success');

  const [darkMode, setDarkMode] = useState(() => 
    window.localStorage.getItem('darkMode') === 'true'
  );

  useAccessTracking();

  async function getQuestionsAnsweredCount(){
    const response = await axios.post(
      `${urlAPI_Current}/getQuestionsAnsweredCount`,
      {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
    }
    );
    if(response.data.countQuestionsAnswered == 0){
      //navigateTo("/questionaryAlert");
      //return;
    } else if (response.data.countQuestionsAnswered >= 1 && response.data.countQuestionsAnswered < 12){
      navigateTo("/questionary");
      return;
    } else if (response.data.countQuestionsAnswered >= 12){
      navigateTo("/resultQuestionary");
      return;
    }

    createModal();
  }

  async function getUserLogged(){
    const user = await userLogged();
    setUserData(user)

    if (!user) { // não tiver usuário, ou authToken invalido
      toast.error('Faça o login primeiro');
      navigateTo('/login');
    } 
    else if(user.codTipoUsuario != 1){
      logoutUser();
      toast.error('Você não tem acesso a essa página');
      navigateTo('/login');
    } else { // loga
        const responsePaid = await verifyUserPaid();
        if(responsePaid.success == true){
          console.log(`Plano Atual ${responsePaid.plan}`);
          await getQuestionsAnsweredCount();
        } else {
          toast.error('Faça o pagamento primeiro');
          navigateTo("/plans");
        }
    }
  }

  const handleLogout = () => {
    navigateTo("/questionary");
  };

  async function createModal() {
      await Swal.fire({
        title: 'Seja bem-vindo ao EVOK!',
        html: "    Para oferecermos uma experiência personalizada e alinhada às suas habilidades, pedimos que responda ao nosso questionário. <br/> <br/> Suas respostas, baseadas em suas opiniões e preferências, nos ajudarão a criar uma jornada única para você.",
        icon: 'info',
        width: '600px',
        didOpen: () => {
          const popup = Swal.getPopup();
          if (popup) {
            popup.style.backgroundColor = darkMode ? '#212121' : '#f0f0f0';
            const popupText = popup.querySelector('.swal2-title');
            if (popupText) {
              popupText.style.color = darkMode ? '#f0f0f0' : '#212121';
            }
      
            const popupTextContent = popup.querySelector('.swal2-html-container');
            if (popupTextContent) {
              popupTextContent.style.color = darkMode ? '#f0f0f0' : '#212121';
              popupTextContent.style.textAlign = 'left'; // Alinha o texto à esquerda
            }
          }
        }
      });
  }

  useEffect(() => {
    getUserLogged();
    
    window.localStorage.setItem('darkMode', darkMode);
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  useEffect(() => {
    verifyAuthToken(navigateTo);
  }, []);

  return (
    <div className={styles.divQuestionary}>
      <Menu darkMode={darkMode}/>
    
      <div className={styles.containerQuestionaryAlert}>
        <div className={styles.welcomeAlert}>
          <h4>
            <strong>Prezado(a) {userData.nome}</strong>
          </h4>
        </div>
        <div className={styles.separatorAlert}></div>
        <div className={styles.alertMessage}>
          <p>
            Você está prestes a iniciar o{" "}
            <strong>
              EVOK™: Diagnostico da Função Performance em Pessoas e Equipes
            </strong>{" "}
            o instrumento nos ajuda a reconhecer um conjunto de habilidades
            especificas que podem potencializar a performance.
          </p>
          <br />
          <p>
            São doze (12) afirmações, e cada uma oferece (quatro) 04 contextos.
            Você deve responder como se posiciona nesses contextos. Para isso dê
            notas de 0-10 a cada afirmativa, podendo ser 10 pontos (100%) numa
            única resposta, ou balancear entre 2 ou mais. Caso necessite de
            suporte adicional clique no ícone <strong>Ajuda</strong> na próxima
            página.
          </p>
          <br />
          <p>
            <strong>Tenha em mente:</strong> não existem respostas certas ou erradas.
            Cada pessoa responde de acordo com sua visão, expectativa, experiência e momento atual.
          </p>
          <p>
            Encontre um local confortável e evite distrações nos próximos minutos.
          </p>
          <p>
            Tempo estimado: <strong>20-30 minutos Atenciosamente,</strong>
          </p>

          <strong>Luis Torres Doutor em Psicologia Positiva</strong>
          <strong> Be Relentless, be Evok</strong>
          <br />
        </div>
        <div className={styles.buttonStartAlert}>
            <button onClick={handleLogout}>Começar</button>
        </div>
      </div>
    </div>
  );
}